import React from "react";
import PropTypes from "prop-types";

import "./UploadProgress.css";

export default function UploadProgress(props){
	if(props.value === -1){
		return null;
	}

	return <progress className="upload-progress" value={props.value} max={props.max} />;
}

UploadProgress.displayName = "UploadProgress";
UploadProgress.defaultProps = {
	value:0,
	max:100,
};
UploadProgress.propTypes = {
	value:PropTypes.number.isRequired,
	max:PropTypes.number.isRequired,
};
